@if (language$ | async; as language) {
  @if (main$ | async; as main) {
    @if (navItems$ | async; as navItems) {
      <!-- Desktop -->
      <div class="row">
        <nav
          class="nav justify-content-between d-none d-lg-flex w-100"
          wlAutomationId="category-desktop"
        >
          <a
            [routerLink]="getRouteUrl(main, language)"
            [class.active]="main.active"
            wlAutomationId="category-all-messages"
            class="nav-link py-2"
          >
            {{ 'AllMessages' | translate }}
          </a>
          @for (menuItem of navItems; track menuItem) {
            <a
              [routerLink]="getRouteUrl(menuItem, language)"
              wlAutomationId="category"
              [class.active]="menuItem.active"
              class="nav-link py-2"
            >
              {{ menuItem.name }}
            </a>
          }
        </nav>
      </div>

      <!-- Mobile -->
      <div class="py-2 d-lg-none">
        <select
          class="form-select form-select-sm"
          role="navigation"
          [ngModel]="selected$ | async"
          wlAutomationId="category-mobile"
          (ngModelChange)="onChange($event, language)"
        >
          <option [ngValue]="main" wlAutomationId="category-all-messages">
            {{ 'AllMessages' | translate }}
          </option>
          @for (menuItem of navItems; track menuItem) {
            <option [ngValue]="menuItem" wlAutomationId="category">
              {{ menuItem.name }}
            </option>
          }
        </select>
      </div>
    }
  }
}
